import moment from "moment";
import { useEffect, useState } from "react";

export const MomentHelpers = {
  formatHelper: function (dateToFormat, locale) {
    if (locale === "en") {
      return moment(dateToFormat).format("MM/DD/YYYY");
    } else {
      return moment(dateToFormat).format("DD/MM/YYYY");
    }
  },
};

function MomentLocalDate(props) {
  const [datetoShow, setDatetoShow] = useState("DD/MM/YYYY");
  const [momentFormat, setMomentFormat] = useState("DD/MM/YYYY");

  const setFormat = (locale) => {
    if (locale === "en") {
      setMomentFormat("MM/DD/YYYY");
    } else {
      setMomentFormat("DD/MM/YYYY");
    }
    setDatetoShow(props.date);
  };

  useEffect(() => {
    setFormat(props.locale);
    // eslint-disable-next-line
  }, []);

  return moment(datetoShow).format(momentFormat);
}

export default MomentLocalDate;
